// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_3xD","cls2":"UserCard-cls2_Nes UserCard-cls1_3xD","small":"UserCard-small_nE6"};